"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiComboBoxInput = exports.List = exports.ComboBoxInput = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../../shared/tokens/tokens"));
var _input = require("../../../../components/inputs/input/input.tokens");
var _globalTokens = require("../../../../shared/global-tokens");
var _Scrollbar = require("../../../layout/scroll/Scrollbar");
var ComboBoxInput = exports.ComboBoxInput = _styledComponents.default.input.withConfig({
  displayName: "ComboboxStyles__ComboBoxInput",
  componentId: "sc-lnu1ih-0"
})(["appearance:none;padding:6px 8px;outline:none;border:none;background:none;margin:0;width:100%;", ";color:", ";height:", ";"], _tokens.default.sky.sys.font.body['1'], function (_ref) {
  var currentItemIsDisabled = _ref.currentItemIsDisabled;
  return currentItemIsDisabled ? _globalTokens.globalColor.text.semantic.error : _globalTokens.globalColor.text.content.main;
}, function (_ref2) {
  var sizeKey = _ref2.sizeKey;
  return _input.tokens.size.height[sizeKey];
});

// style overrides for multi combobox, on large sizes we let the height be controlled by padding around the content
// since it also contains a list of selected items
var MultiComboBoxInput = exports.MultiComboBoxInput = (0, _styledComponents.default)(ComboBoxInput).withConfig({
  displayName: "ComboboxStyles__MultiComboBoxInput",
  componentId: "sc-lnu1ih-1"
})(["width:auto;height:", ";"], function (_ref3) {
  var sizeKey = _ref3.sizeKey;
  return sizeKey === _input.InputHeight.SMALL ? _input.tokens.size.height[_input.InputHeight.SMALL] : 'auto';
});
var List = exports.List = _styledComponents.default.ul.withConfig({
  displayName: "ComboboxStyles__List",
  componentId: "sc-lnu1ih-2"
})(["max-height:300px;list-style:none;overflow:auto;padding:0;margin:0;z-index:auto;outline:none;width:100%;", ";"], _Scrollbar.scrollbarGlobalStyle);